<div class="w-100">
  <div class="header" *ngIf="dialogData?.isOpenedFromDashboard">
<div class="d-flex w-100 py-3 px-4">
            <div class="me-2 id flex-fill">
              <h4 class="modal-title mb-0 item-id">
                Leads - {{ dialogData?.filteredStatus }}
              </h4>
            </div>

            <div class="btns-header">
              <button class="close" (click)="dialogRef.close()" aria-label="Close">
                <i class="fas fa-times" title="Close Popup"></i>
              </button>
              <!-- <button class="close expand-modal" (click)="expandCollapse()">
                <i class="fas ms-2 me-2" style="font-weight: bold;" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
              </button> -->
            </div>
          </div>
  </div>
  <app-loader *ngIf="showLoader"></app-loader>
  <ejs-grid *ngIf="showGrid" #leadsGrid [id]="gridName" [dataSource]="dataSource" [allowPaging]="false" [enableInfiniteScrolling]="true" [enableVirtualization]="false" [enableVirtualMaskRow]="false" [infiniteScrollSettings]="infiniteScrollSettings"
    [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 200 }" [gridLines]="false" [allowFiltering]="true"
    [showColumnChooser]="true" [height]="gridHeight" [enablePersistence]="true" [allowSorting]="true"
    [enableHover]="false" [allowResizing]="true" [allowReordering]="true" [allowExcelExport]="true"
    [allowSelection]="true" [searchSettings]="searchSettings" [editSettings]="{ allowEditing: false }"
    [filterSettings]="{ type: 'Menu' }" [query]="query" (toolbarClick)="onToolbarClick($event)" (rowDataBound)="onRowDataBound($event)" (created)="onCreated($event, leadsGrid)"
    (commandClick)="commandClick($event, leadsGrid)" (dataBound)="dataBound($event)" (actionBegin)="onActionBegin($event)" (actionComplete)="onGridActionComplete($event, leadsGrid)">
    <e-columns>
      <e-column *ngFor="let column of columns;" [field]="column.field" [headerText]="column.headerText"
        [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'" [type]="column.type" [width]="column.width"
        [filter]="column.filter ? column.filter : { type: 'Menu' }" [format]="column.format ? column.format : null"
        [textAlign]="column.textAlign" [showInColumnChooser]="column.showInColumnChooser" [visible]="column.visible"
        [commands]="column?.commands ? column.commands : null" [edit]="column.edit"
        [allowReordering]="column.allowReordering ?? true" [freeze]="column.freeze ? column.freeze: null"
        [allowEditing]="column.allowEditing" [allowSorting]="column.allowSorting"
        [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
        <ng-template *ngIf="column.field === 'statusText'" #template let-data>
          <span class="grid-status-column"
            [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
        </ng-template>
        <ng-template *ngIf="column.field === 'salesLeadId'" #template let-data>
          <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
        </ng-template>

        <ng-template *ngIf="column.field === 'soldToBPName'" #template let-data>
          @if (dialogData?.filteredStatus){
              {{data.soldToExtId+" - "+data.soldToBPName}}
          } @else {
            @if(data.soldToExtId) {
              <a href="javascript:" (click)="onBPIdClick(data.soldToExtId)">{{data.soldToBPName}}</a>
            } @else {
              {{data.soldToBPName}}
            }
          }
        </ng-template>


      </e-column>
    </e-columns>
  </ejs-grid>
<div class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
    <div class="grid-total-count" style="font-weight:600;">
        Total Records: {{totalRecords | number}}
    </div>
</div>


  <!-- <div class="d-flex justify-content-end my-2 mx-4" *ngIf="dialogData?.isOpenedFromDashboard">
    <button type="button" class="btn btn-danger footer-buttons" (click)="dialogRef.close()">
      Close
    </button>
  </div> -->
</div>

<ng-template #columnChooser>
  <app-column-chooser [grid]="grid"></app-column-chooser>
</ng-template>

<ng-template #addLeads>
  <i *ngIf="rolePermissions['leadsGrid_add']?.visible" class="fas fa-add"></i>
</ng-template>

<!-- <app-prospects-popup *ngIf="showProspectsPopup" [prospectData]="prospectData" [tab]="'details'"
  (onClose)="showProspectsPopup = false">
</app-prospects-popup> -->
